/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Offcanvas } from 'react-bootstrap';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faBarcode } from '@fortawesome/free-solid-svg-icons';
import FeatherIcon from 'feather-icons-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Button from 'components/base/Button';
import RemainderCreateFiltert from './RemainderCreateFilter';
import reportInvoiceService from 'service/reportInvoice';
import { useWindowWidth } from 'utils/useWindowSize';

interface RemainderFilterProps {
  setGeneratedTableData?: any;
  savedValues?: any;
  setSavedValues?: any;
  setGetName?: any;
  setGetBarcode?: any;
  getName?: any;
  getBarcode?: any;
  setGetFilterData?: any;
  setCurrencyName?: any;
  setTotalQuantity?: any;
  setTotalincome?: any;
  setTotalSale?: any;
  currentPage?: any;
  setPageCount?: any;
  getFilterData?: any;
  barcodeInputRef: any;
  setDebouncedBarcode?: any;
  setCurrentPage?: any;
  labeledVisibleFields?: any;
}

const RemainderFilter = ({
  setGeneratedTableData,
  savedValues,
  setSavedValues,
  setGetName,
  setGetBarcode,
  getName,
  getBarcode,
  setGetFilterData,
  setCurrencyName,
  setTotalQuantity,
  setTotalincome,
  setTotalSale,
  currentPage,
  setPageCount,
  getFilterData,
  barcodeInputRef,
  setDebouncedBarcode,
  setCurrentPage,
  labeledVisibleFields
}: RemainderFilterProps) => {
  const url = process.env.REACT_APP_CDN_URL;
  const currencyId = useSelector(
    (state: any) => state?.auth?.legal_entity?.currency_pid
  );

  const branchId = useSelector((state: any) => state?.auth?.legal_entity?.pid);

  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const windowSize: any = useWindowWidth();

  const handleExport = () => {
    setLoading(true);
    const customFilename: string = 'Остаток.xlsx';

    // Prepare request payload
    const requestData = {
      name: getName,
      date: getFilterData?.date_on ? getFilterData?.date_on : undefined,
      barcode: getBarcode,
      currency_pid:
        Object.keys(getFilterData).length === 0
          ? currencyId
          : getFilterData?.currency_pid,
      branch_pid:
        Object.keys(getFilterData).length === 0
          ? branchId
          : getFilterData?.branch_pid,
      is_group: true,
      /* prettier-ignore */
      is_negative:
        Object.keys(getFilterData).length === 0
            ? true
          : getFilterData?.is_negative
            ? getFilterData?.is_negative
            : true,
      visible_columns: labeledVisibleFields,
      ...getFilterData
    };

    // Fetch report and trigger download
    reportInvoiceService
      ?.getReportRemainingListExcel(requestData)
      .then((res: any) => {
        setLoading(false);
        if (res?.filename !== '') {
          const resUrl = `${url}${res?.filename}`;
          const link = document.createElement('a');
          link.href = resUrl;
          link.download = customFilename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch(error => {
        setLoading(false);
        console.log('error==>', error);
      });
  };

  return (
    <div>
      <Form
        className={
          windowSize > 768 ? 'd-flex gap-3' : 'd-flex gap-2 flex-column'
        }
      >
        <div className="d-flex gap-2">
          <div className="form-icon-container">
            <Form.Floating>
              <Form.Control
                type="text"
                placeholder={t('enter_product')}
                onFocus={e => e.target.select()}
                onChange={e => setGetName(e.target.value)}
                className="form-icon-input"
              />
              <label
                htmlFor="floatingInputCustom"
                className="form-icon-label text-700"
              >
                {t('enter_product')}
              </label>
            </Form.Floating>
            <FontAwesomeIcon
              icon={faSearch}
              className="text-900 fs-9 form-icon"
            />
          </div>

          <div className="form-icon-container">
            <Form.Floating>
              <Form.Control
                ref={barcodeInputRef}
                type="text"
                placeholder={t('scan_barcode')}
                onFocus={e => e.target.select()}
                onChange={e => setGetBarcode(e.target.value)}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    e.preventDefault(); // Prevent form submission or unintended behavior
                    setCurrentPage(1);
                    setDebouncedBarcode(getBarcode);
                  }
                }}
                className="form-icon-input"
              />
              <label
                htmlFor="floatingInputCustom"
                className="form-icon-label text-700"
              >
                {t('scan_barcode')}
              </label>
            </Form.Floating>
            <FontAwesomeIcon
              icon={faBarcode}
              className="text-900 fs-9 form-icon"
            />
          </div>
        </div>

        <div className="d-flex gap-2">
          <Button
            className="d-flex align-items-center gap-2"
            style={{ height: '48px' }}
            variant="outline-primary"
            onClick={() => setOpenModal(true)}
          >
            <FeatherIcon icon="filter" size={20} />
            {t('filter')}
          </Button>

          <Button
            className="d-flex align-items-center gap-2"
            style={{ height: '48px' }}
            variant="outline-primary"
            onClick={handleExport}
            loading={loading}
            loadingPosition="start"
          >
            <FeatherIcon icon="upload-cloud" size={20} />
            {t('export')}
          </Button>
        </div>

        <Offcanvas
          show={openModal}
          onHide={() => {
            setOpenModal(false);
          }}
          placement="end"
          backdrop="static"
          keyboard={false}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title style={{ fontSize: '24px', fontWeight: '600' }}>
              {t('filter')}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <RemainderCreateFiltert
              setGeneratedTableData={setGeneratedTableData}
              savedValues={savedValues}
              setSavedValues={setSavedValues}
              setOpenModal={setOpenModal}
              getName={getName}
              getBarcode={getBarcode}
              setGetFilterData={setGetFilterData}
              setCurrencyName={setCurrencyName}
              setTotalQuantity={setTotalQuantity}
              setTotalincome={setTotalincome}
              setTotalSale={setTotalSale}
              currentPage={currentPage}
              setPageCount={setPageCount}
            />
          </Offcanvas.Body>
        </Offcanvas>
      </Form>
    </div>
  );
};

export default RemainderFilter;
